export default "__VITE_ASSET__t3pwGHCa__"